import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  InvestorJoinContent,
  Footer,
} from '../../components';
import config from '../../config';

import css from './InvestorsJoinPage.module.css';

const InvestorsJoinPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'JoinUsPage.joinusTabTitle' }),
      selected: false,
      linkProps: {
        name: 'JoinUsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommProfJoinPage.commprofTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommProfJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'DeafCommJoinPage.deafcommTabTitle' }),
      selected: false,
      linkProps: {
        name: 'DeafCommJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'InvestorsJoinPage.investorsTabTitle' }),
      selected: true,
      linkProps: {
        name: 'InvestorsJoinPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'InvestorsJoinPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="InvestorsJoinPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="InvestorsJoinPage.heading" />
            </h1>
            <InvestorJoinContent />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

InvestorsJoinPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const InvestorsJoinPage = compose(
  connect(mapStateToProps),
  injectIntl
)(InvestorsJoinPageComponent);

export default InvestorsJoinPage;
